import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../AppContext';
import { Types } from '../../enums/TypeEnums';
import { IStock, useStockQuery } from '../../generated/graphql';
import { canUserEdit } from '../../utils/rightUtils';
import { AuthRoutes, RouteNames } from '../../enums/RouteEnums';
import { Box, Button, IconButton, Link } from '@mui/material';
import OverviewToolbar from '../Common/Layout/OverviewToolbar';
import { Colors } from '../../utils/theme';
import { DoubleArrow, Edit } from '@mui/icons-material';
import ToolBarButton from '../Common/Buttons/ToolBarButton';
import StockDetails from './StockDetails';
import { IHistoryStock } from '../../generated/graphql';
import Loader from '../Common/Loader';
import StockTabs from './StockTabs';

const StockInfoWrapper: React.FunctionComponent = () => {
  const location = useLocation();
  console.log('location state: ', location.state);
  const history = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [open, setOpen] = useState(true);
  const [stock, setStock] = useState<IStock | null>(null);
  const [triggerSave, setTriggerSave] = useState(0);
  const { state } = useContext(AppContext);
  const canEdit = canUserEdit(state.user, Types.Stock);

  const locationElements = location.pathname.split('/').filter((e) => e);
  const { data, loading } = useStockQuery({
    variables: {
      id: parseInt(locationElements[locationElements.length - 1])
    },
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (data?.result) {
      setStock(data.result as IStock);
    }
  }, [data]);

  const handleToStocksOverview = () => {
    history(AuthRoutes.Stocks);
  };

  const handleUpdatedStock = (input: IStock) => {
    setStock(input);
    setIsEditMode(false);
    setTriggerSave(0);
  };

  return (
    <Box sx={{ width: '100%', height: '100vh', display: 'flex', flexFlow: 'column' }}>
      <OverviewToolbar
        handleToOverview={handleToStocksOverview}
        navName={RouteNames.Stocks}
        isManualStyles={true}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: '100%', pl: '40%' }}
        >
          <span>{stock?.name}</span>
          <span style={{ color: Colors.white }}>
            {isEditMode ? (
              <Box style={{ width: '260px' }}>
                <ToolBarButton
                  id="cancel-stock-button"
                  data-testid="cancel-stock-button"
                  onClick={() => setIsEditMode(false)}
                  text="Cancel"
                />
                <ToolBarButton
                  id="save-stock-button"
                  data-testid="save-stock-button"
                  onClick={() => setTriggerSave(triggerSave + 1)}
                  text={isEditMode ? 'Save' : 'Create'}
                  type="secondary"
                />
              </Box>
            ) : (
              <Box style={{ width: '260px', textAlign: 'right' }}>
                <Button
                  id="stock-edit-button"
                  data-testid="stock-edit-button"
                  component={Link}
                  disabled={!canEdit}
                  onClick={() => setIsEditMode(true)}
                >
                  <Edit
                    style={{
                      fontSize: 'medium',
                      color: Colors.white,
                      marginRight: 3
                    }}
                  />
                  <span style={{ color: Colors.white, textDecoration: 'underline' }}>EDIT</span>
                </Button>
              </Box>
            )}
          </span>
        </Box>
      </OverviewToolbar>
      <Box
        sx={{
          position: 'relative',
          background: '#0EAEFF1A',
          borderBottom: `1px solid ${Colors.skyBlue}`,
          height: open ? '235px' : '20px',
          transition: 'height 1s, transform 1s;'
        }}
      >
        {open && (
          <StockDetails
            stock={stock}
            editable={isEditMode}
            saveTriggered={triggerSave}
            refreshStock={handleUpdatedStock}
            historyStock={(location.state as IStock).historyStock as IHistoryStock}
          />
        )}
        <IconButton
          onClick={() => setOpen(!open)}
          aria-label="delete"
          size="small"
          style={{
            width: '20px',
            height: '20px',
            background: Colors.white,
            boxShadow: '0px 3px 6px #2274BC96',
            opacity: 1,
            marginRight: '5%',
            alignSelf: 'end',
            zIndex: 3,
            position: 'absolute',
            bottom: '-10px',
            right: 0
          }}
        >
          <DoubleArrow
            style={{
              fontSize: 'small',
              color: Colors.skyBlue,
              transform: open ? 'rotate(270deg)' : 'rotate(90deg)'
            }}
          />
        </IconButton>
      </Box>
      <StockTabs
        stockId={stock?.id}
        stockName={stock?.name}
        currencyCode={stock?.currency?.code}
        companyName={stock?.company.name}
      />
      <Loader loading={loading} />
    </Box>
  );
};

export default StockInfoWrapper;
